import { render } from "./ExamDataCenter.vue?vue&type=template&id=09cc4781&scoped=true"
import script from "./ExamDataCenter.vue?vue&type=script&lang=js"
export * from "./ExamDataCenter.vue?vue&type=script&lang=js"

import "./ExamDataCenter.vue?vue&type=style&index=0&id=09cc4781&lang=scss&scoped=true"
import "./ExamDataCenter.vue?vue&type=style&index=1&id=09cc4781&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09cc4781"]])

export default __exports__